import React from 'react';

import type * as api from '@gitbook/api-client';
import type { AnalyticsContextSpaceContent } from '@gitbook/app-analytics/client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { SidePanelSheet } from '@gitbook/react-uikit';

import { HiveBranchHistory } from '../../../Components';
import { useNavigation, useSetAnalyticsScreen } from '../../../navigation';

/**
 * Side panel showing the history of a space or change request.
 */
export function HistorySidePanel(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
    screen: NavigationScreenSpaceState;
    analyticsContext: AnalyticsContextSpaceContent;
}): React.ReactElement | null {
    const { space, changeRequest, screen, analyticsContext } = props;

    const { navigate } = useNavigation();

    const activeRevisionId = screen.revision;
    const initialRevisionId = changeRequest ? changeRequest.revision : space.revision;

    useSetAnalyticsScreen({ ...analyticsContext, screen: 'space_activity' });

    const onClose = React.useCallback(() => {
        navigate({
            current: {
                revision: undefined,
                sideSheet: undefined,
                mode: undefined,
            },
        });
    }, [navigate]);

    return (
        <>
            <SidePanelSheet title="Version history" onClose={onClose}>
                <HiveBranchHistory
                    space={space}
                    changeRequest={changeRequest}
                    initialRevisionId={initialRevisionId}
                    activeRevisionId={activeRevisionId}
                    readOnly={!space.permissions.merge}
                />
            </SidePanelSheet>
        </>
    );
}
